import React from 'react';
import SectionContainer from '../../common/SectionContainer';
import { formatCurrency } from '../../common/formatUtils';
import { CREDITOS_IDPC } from '../../../../../services/dj1947/calculo';

const creditosIdpc = (fila) => CREDITOS_IDPC.reduce((total, credito) => total + (fila[credito.campo] || 0), 0);

// Lo que la DJ 1947 asigna a cada propietario, que tributa con impuestos finales
const PropietariosSection = ({ computed }) => {
  const filas = computed.propietarios || [];
  const t = computed.totalesPropietarios || {};
  return (
    <SectionContainer title="Propietarios" subtitle="Base imponible, créditos y PPM asignados según la DJ 1947">
      <div className="f22-subsection">
        <div className="f22-subtable">
          <div className="f22-subtable-header">
            <div className="f22-subtable-cell" style={{ flex: 3 }}>Propietario</div>
            <div className="f22-subtable-cell">%</div>
            <div className="f22-subtable-cell">Base imponible ($)</div>
            <div className="f22-subtable-cell">Créditos IDPC ($)</div>
            <div className="f22-subtable-cell">Crédito 33 bis ($)</div>
            <div className="f22-subtable-cell">PPM ($)</div>
            <div className="f22-subtable-cell">Certificado</div>
          </div>
          {filas.map((fila) => (
            <div key={fila.rut} className="f22-subtable-row">
              <div className="f22-subtable-cell" style={{ flex: 3 }}>{fila.nombre} · {fila.rut}</div>
              <div className="f22-subtable-cell"><span className="f22-computed-value">{Number(fila.porcentaje).toLocaleString('es-CL', { maximumFractionDigits: 4 })}%</span></div>
              <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(fila.base_imponible)}</span></div>
              <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(creditosIdpc(fila))}</span></div>
              <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(fila.credito_33_bis)}</span></div>
              <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(fila.ppm)}</span></div>
              <div className="f22-subtable-cell"><span className="f22-computed-value">{fila.numero_certificado}</span></div>
            </div>
          ))}
          <div className="f22-subtable-row f22-subtable-totals">
            <div className="f22-subtable-cell" style={{ flex: 3 }}>Total ({t.casos || 0} propietarios)</div>
            <div className="f22-subtable-cell" />
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(t.base_imponible || 0)}</span></div>
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(creditosIdpc(t))}</span></div>
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(t.credito_33_bis || 0)}</span></div>
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(t.ppm || 0)}</span></div>
            <div className="f22-subtable-cell" />
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default PropietariosSection;
